import Vue from 'vue'
import Vuex from 'vuex'
import { alert } from './store/alert.module';
import { users } from './store/users.module';
import { categories } from './store/categories.module';
import { orders } from './store/orders.module';
import { palettes } from './store/palettes.module';
import { posts } from './store/posts.module';
import { products } from './store/products.module';
import { staticInfos } from './store/staticInfos.module';
import { keyValues } from './store/keyValues.module';
import { banners } from './store/banners.module';

Vue.use(Vuex)

const state = {
  sidebarShow: 'responsive',
  sidebarMinimize: false
}

const mutations = {
  toggleSidebarDesktop (state) {
    const sidebarOpened = [true, 'responsive'].includes(state.sidebarShow)
    state.sidebarShow = sidebarOpened ? false : 'responsive'
  },
  toggleSidebarMobile (state) {
    const sidebarClosed = [false, 'responsive'].includes(state.sidebarShow)
    state.sidebarShow = sidebarClosed ? true : 'responsive'
  },
  set (state, [variable, value]) {
    state[variable] = value
  }
}

export default new Vuex.Store({
  namespaced: true,
  state,
  mutations,
  modules: {alert,users,categories,orders,palettes,posts,products,staticInfos,keyValues,banners}
});